import React from 'react'
import _ from 'underscore'
import { ChevronDown, Funnel } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import store from '../../../state/store'

class PipelineStatusButton extends React.Component {

  onSelect = (value) => {
    store.emit('enquiry:workflow_state:update', this.props.enquiry_id, value)
  }

  getWorkflowStateName = (workflow_state) => {
    let workflow_state_name = workflow_state

    if (workflow_state === 'new_opportunity')
      workflow_state_name = 'Claim'
    else if (workflow_state === 'qualify')
      workflow_state_name = 'Qualify'
    else if (workflow_state === 'first_call_scheduled')
      workflow_state_name = 'Contact'
    else if (workflow_state === 'consideration')
      workflow_state_name = 'Convincing'
    else if (workflow_state === 'engaging_student')
      workflow_state_name = 'Confirmation'
    else if (workflow_state === 'collecting_payment')
      workflow_state_name = 'Collecting Payment'
    else if (workflow_state === 'closing')
      workflow_state_name = 'Close'

    return workflow_state_name.replace(/\_/g, ' ')
  }

  render() {
    let currentName = this.getWorkflowStateName(this.props.workflow_state)

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" size="sm">
            <Funnel className="size-3.5"/> {currentName} <ChevronDown className="size-3.5"/>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {_.map(this.props.workflow_states, (workflow_state) => {
            let name = this.getWorkflowStateName(workflow_state)

            return (
              <PipelineStatusOption
                key={workflow_state}
                name={name}
                value={workflow_state}
                onSelect={this.onSelect} />
            )
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }
}

class PipelineStatusOption extends React.Component {

  onSelect = () => {
    this.props.onSelect(this.props.value)
  }

  render() {
    return (
      <DropdownMenuItem onSelect={this.onSelect}>{this.props.name}</DropdownMenuItem>
    )
  }
}

export default PipelineStatusButton
